import { FormProvider } from "react-hook-form";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/view/components/ui/dialog";
import { BasicInput } from "@/view/components/BasicInput";
import { Button } from "@/view/components/ui/button";
import { Skeleton } from "@/view/components/ui/skeleton";
import { cpfMask } from "@/app/utils/cpfFormater";
import { phoneMask } from "@/app/utils/phoneFormater";
import masks from "@/app/utils/masks";
import usePersonalInfoFormModal from "./usePersonalInfoFormModal";

interface PersonalInfoFormModalProps {
  onBack: () => void;
  onContinue: () => void;
}

export default function PersonalInfoFormModal({
  onBack,
  onContinue,
}: PersonalInfoFormModalProps) {
  const { form, commisionData, isLoadingCommisionData, submitModal } =
    usePersonalInfoFormModal({
      onContinue,
    });

  const {
    formState: { errors },
  } = form;

  return (
    <DialogContent className="flex max-h-[90vh] w-[95vw] max-w-3xl flex-col overflow-y-auto">
      <DialogHeader className="flex flex-row items-start justify-between border-b pb-8">
        <div>
          <DialogTitle className="text-xl font-semibold text-black01">
            Indicação Salvcar
          </DialogTitle>
          <DialogDescription className="!mt-0 text-base text-black04">
            Preencha os campos para gerar a proposta
          </DialogDescription>
        </div>
      </DialogHeader>

      <form onSubmit={submitModal}>
        <FormProvider {...form}>
          <div className="mt-2 flex flex-col space-y-5">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              <div className="flex flex-col gap-2 md:col-span-1">
                <BasicInput
                  name="cpf"
                  label="CPF"
                  error={errors.cpf?.message}
                  onInput={cpfMask}
                  maxLength={14}
                />
              </div>

              <div className="flex items-end justify-end md:col-span-1">
                {isLoadingCommisionData ? (
                  <Skeleton className="h-8 w-60" />
                ) : (
                  commisionData && (
                    <div className="flex flex-col space-y-1 text-right">
                      <div className="ml-auto w-max rounded-full bg-primary px-3 py-1 shadow-lg">
                        <p className="text-sm font-semibold text-white">
                          {masks.currency(
                            Number(commisionData?.range.from ?? 0),
                          )}
                          {" - "}
                          {masks.currency(Number(commisionData?.range.to ?? 0))}
                        </p>
                      </div>
                      <p className="max-w-[16rem] text-xs text-black04">
                        O valor de comissão está sujeito a mudança pós validação
                        dos dados.
                      </p>
                    </div>
                  )
                )}
              </div>

              <div className="md:col-span-2">
                <BasicInput
                  name="name"
                  label="Nome"
                  error={errors.name?.message}
                />
              </div>

              <BasicInput
                name="email"
                label="E-mail"
                error={errors.email?.message}
                maxLength={30}
              />
              <BasicInput
                name="phone"
                label="Telefone"
                error={errors.phone?.message}
                onInput={phoneMask}
              />
            </div>
          </div>

          <div className="mt-8 flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              className="w-[160px] rounded-full text-primary"
              onClick={onBack}
            >
              Voltar
            </Button>
            <Button
              type="submit"
              className="w-[160px] rounded-full font-semibold text-white"
            >
              Continuar
            </Button>
          </div>
        </FormProvider>
      </form>
    </DialogContent>
  );
}
